import React from 'react';
import selectors from '../hooks/selectors';
import RequestLinksDialog from './RequestLinksDialog';
import RequestObjectDialog from './RequestObjectDialog';

const RequestFormDialogs = ({ theme }) => {
  const { allowLinks, allowObjects } = selectors.useRequestFormDialogs();
  return (
    <>
      {allowLinks && (<RequestLinksDialog theme={theme} />)}
      {allowObjects && (<RequestObjectDialog theme={theme} />)}
    </>
  );
};

export default RequestFormDialogs;
